import { Moment } from 'moment';
import { ContactTarget } from '@/customer/models/Customer';
import Outlet from '@/shared/models/Outlet';
import { isTruthy } from '@/shared/utils/typescript';
import Vehicle from '@/vehicle/models/Vehicle';

export default class Keydrop {
  keyDropOn: Moment | null = null;
  locationDescription = '';
  outlet!: Outlet;
  vehicle!: Vehicle;
  mobileNumber = '';
  emailAddress = '';
  customerName = '';
  reasonOfVisit = '';
  parkingLocation = '';

  getContactTargets(): Array<ContactTarget> {
    return [this.emailAddress, this.mobileNumber].filter(isTruthy);
  }
}
